import React, { Dispatch } from 'react';
import { Box, Button, Collapse } from '@mui/material';
import { classes } from '../../Job/Applications/styles';
import MergeTypeIcon from '@mui/icons-material/MergeType';
import DeleteIcon from '@mui/icons-material/Delete';
import { ITableColumns, TemplateTableAction, TemplateTableState } from '../types';
import { ModalType } from '../config';

export default function TagManagerActionsPanel({
  templatePageState,
  templatePageDispatch
}: {
  templatePageState: TemplateTableState<ITableColumns>;
  templatePageDispatch: Dispatch<TemplateTableAction>;
}) {
  return (
    <Collapse in={templatePageState.templateTableState.selectedItems.length >= 1}>
      <Box sx={classes.actionsContianer}>
        <Button
          id="tags-action-applications-button"
          variant="outlined"
          startIcon={<MergeTypeIcon />}
          sx={classes.actionButton}
          onClick={() =>
            templatePageDispatch({ type: 'SET_MODALS_OPEN', payload: ModalType.MERGE_TAGS })
          }
        >
          Merge Tags
        </Button>
        <Button
          id="tags-bulk-delete-button"
          variant="outlined"
          startIcon={<DeleteIcon sx={{ color: '#E37D7A' }} />}
          sx={{ ...classes.actionButton, marginLeft: 2 }}
          onClick={() =>
            templatePageDispatch({ type: 'SET_MODALS_OPEN', payload: ModalType.BULK_DELETE_TAGS })
          }
        >
          Bulk Delete
        </Button>
      </Box>
    </Collapse>
  );
}
